export function isApiAuth(params) {
    return "loginApiAuthAsync" in params;
}
